import React, { useEffect, useState } from 'react';
import {ReactComponent as Logo} from '../Images/logo.svg';
import {ReactComponent as Menu} from '../Images/bars-solid.svg'
import { Link } from 'react-router-dom';

export const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  // const [homeselected, setHomeSelected] = useState(false);
  let menu;
  if(showMenu){
    menu = <div className='fixed bg-white w-2/5 h-52 right-2 top-[4.7rem] z-40 shadow-md'>
        <div className='text-center font-bold py-3'>
          <Link to='/' className='text-sm' onClick={() => setShowMenu(!showMenu)}>Home</Link>
          {/* <Link to='/' className={`${homeselected} ? underline decoration-indigo-500 decoration-2 : text-sm`} onFocus={() => setHomeSelected(!homeselected)} >Home</Link> */}
        </div>
        <div className='text-center font-bold py-3'>
          <Link to='/about' className='text-sm' onClick={() => setShowMenu(!showMenu)}>About Us</Link>
        </div>
        <div className='text-center font-bold py-3'>
          <Link to='/' className='text-sm' onClick={() => setShowMenu(!showMenu)} >Services</Link>
        </div>
        <div className='text-center font-bold py-3'>
          <a className='text-sm' href="https://forms.gle/GQau6SwBjhZwZmo46">Contact</a>
        </div>
    </div>
  }

  const [show, setShow] = useState(false);
  
  const transitionnavBar = () => {
      if(window.scrollY>90){
          setShow(true);
      } else{
          setShow(false);
      }
  }

  useEffect(() => {
      window.addEventListener("scroll", transitionnavBar);
      return () => {
          window.removeEventListener("scroll", transitionnavBar);
      }
  }, [])


  return (
    <>
      <div className={`flex flex-row flex-1 w-full justify-between pr-5 z-10 lg:z-30 shadow-md lg:shadow-md bg-white lg:bg-[#e2f6ff] lg:h-20 transition-all ease-in duration-200 lg:transition-all lg:ease-in lg:duration-100 ${show && 'fixed top-0 z-10 lg:h-14 lg:align-middle'}`}>
          <Link to='/'><Logo className={`w-32 mx-6 my-4 lg:my-6 lg:mx-12 ${show && 'lg:my-2'}`} /></Link>
          {/* For Mobile  */}
          <div className='lg:hidden mt-6 right-0'>
            <Menu className='w-6' onClick={() => setShowMenu(!showMenu)} />
          </div>
          {menu}
          {/* For Desktop */}
          <div className='hidden lg:block lg:flex lg:flex-row lg:right-0'>
            <Link className={`lg:mx-8 lg:pt-8 lg:font-semibold lg:hover:underline lg:hover:decoration-[#0e719c] lg:hover:decoration-4 lg:hover:underline-offset-4 ${show && 'lg:pt-4'}`} to='/'>Home</Link>
            <Link className={`lg:mx-8 lg:pt-8 lg:font-semibold lg:hover:underline lg:hover:decoration-[#0e719c] lg:hover:decoration-4 lg:hover:underline-offset-4 ${show && 'lg:pt-4'}`} to='/about'>About Us</Link>
            <Link className={`lg:mx-8 lg:pt-8 lg:font-semibold lg:hover:underline lg:hover:decoration-[#0e719c] lg:hover:decoration-4 lg:hover:underline-offset-4 ${show && 'lg:pt-4'}`} to='/'>Services</Link>
            <a className={`lg:mx-8 lg:pt-8 lg:font-semibold lg:hover:underline lg:hover:decoration-[#0e719c] lg:hover:decoration-4 lg:hover:underline-offset-4 ${show && 'lg:pt-4'}`} href="https://forms.gle/GQau6SwBjhZwZmo46" target='_blank' rel="noreferrer">Contact Us</a>
          </div>
      </div>
    </>
  );
}